import React, { useState, useRef } from 'react';
import { Paperclip, Briefcase, FileText, X, Loader2 } from 'lucide-react';
import './SearchBox.css';

const SearchBox = ({ onSearch, isLoading, query, onQueryChange, cvFile, onCvChange }) => {
  const [isFocused, setIsFocused] = useState(false);
  const fileInputRef = useRef(null);

  const handleSearch = (e) => {
    e.preventDefault();
    if ((query.trim() || cvFile) && !isLoading) {
      onSearch({ query: query.trim(), cvFile });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onCvChange(file);
    }
  };

  const removeCv = () => {
    onCvChange(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <form className={`search-box ${isFocused ? 'search-box--focused' : ''}`} onSubmit={handleSearch}>
      <div className="search-box__input-area">
        <textarea
          className="search-box__input"
          placeholder="İstanbul, satış temsilcisi, 5 yıl tecrübeliyim"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          rows={1}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSearch(e);
            }
          }}
        />
      </div>

      {cvFile && (
        <div className="search-box__cv-badge">
          <FileText size={14} />
          <span>{cvFile.name}</span>
          <button type="button" className="search-box__cv-remove" onClick={removeCv}>
            <X size={14} />
          </button>
        </div>
      )}

      <div className="search-box__actions">
        <div className="search-box__left-actions">
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.doc,.docx"
            className="search-box__file-input"
            onChange={handleFileChange}
            id="cv-upload"
          />
          <label htmlFor="cv-upload" className="search-box__cv-btn">
            <Paperclip size={16} />
            <span>CV Yükle</span>
          </label>
        </div>

        <div className="search-box__right-actions">
          <button type="submit" className="search-box__submit" disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 size={18} className="search-box__spinner" />
                <span>Aranıyor...</span>
              </>
            ) : (
              <>
                <Briefcase size={18} />
                <span>İş Bul</span>
              </>
            )}
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchBox;
